export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
  }).format(amount);
};

export const parseCurrency = (value: string): number => {
  // Remove currency symbols and parse
  return parseFloat(value.replace(/[^0-9,-]/g, '').replace(',', '.'));
};